
import confetti from "canvas-confetti";

export const launchConfetti = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    angle: 90,
  });
};
